export default {
	state: {
		consultoriaAgendamento: {}
	},
	getters: {
		"consultoriaAgendamento": state => state.consultoriaAgendamento
	},
	mutations: {
		setConsultoriaAgendamento(state, payload) {
			state.consultoriaAgendamento = payload
		}
	},
	actions: {
		atualizarEstadoConsultoriaAgendamento({ commit }, payload) {
			commit('setConsultoriaAgendamento', payload)
		}
	}
};